<!-- <div [class]="'call-to-action ' + classModal">
    <div class="content lightbox-content-show">
        <div class="content-header">
            <div href="" class="icon-hide close-call icon-close" style="cursor:pointer;" (click)="eventoCerrarModal()">
            </div>
        </div>
        <h2 class="text-center">¿Estás seguro que deseas cerrar sesión?</h2>
        <div class="buttons">
            <button (click)="eventoCerrarSession()" class="btn btn-secondary btn-logout">Salir</button>
        </div>
    </div>
</div> -->


<!-- Fondo oscuro (solo detrás del modal) -->
<div class="modal-backdrop fade show" *ngIf="isVisible"></div>

<!-- Contenedor del modal -->
<div class="custom-modal d-block" tabindex="-1" role="dialog" *ngIf="isVisible">
    <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content shadow-lg border-0 rounded">


            <div class="content-header">
                <div (click)="close()"
                    class="close-btn-modal" >
                </div>
            </div>
            <!-- <div class="modal-header">
                <img src="assets/icons/bds_ic_information.png" alt="Información" />
            </div> -->

            <div class="modal-body">
                <h5 class="modal-title">{{ title }}</h5>
                <p [innerHTML]="message"></p>

            </div>

            <div class="modal-footer">
                <button (click)="close()" type="button" class="btn btn-primary">
                    Volver
                </button>
                <button (click)="eventoCerrarSession()" type="button" class="btn btn-secondary">
                    Salir
                </button>
            </div>
        </div>
    </div>
</div>

